import React from 'react';

export interface ModalContextType {
	setLabelMeta: (labelID: string) => void;
	setContentMeta: (contentID: string) => void;
}

export const ModalContext = React.createContext({
	setLabelMeta: () => {},
	setContentMeta: () => {},
} as ModalContextType);
